export enum IzobrazevanjeStatus {
    VPripravi = 0,
    Objavljeno = 1
}

export enum IzobrazevanjeTipStatus {
    Neznano = 0,
    Aktivno = 1,
    Arhivirano = 9
}

export enum IzobrazevanjeVrsta {
    Navadno = 1,
    Javno = 2
}

export enum IzobrazevanjeLokacijaVrsta {
    URL = 1,
    Fizicno = 2,
    eCampus = 3
}

export enum UserRole {
    Administrator,
    User
}

export enum PodrocjeStatus {
    Neznano = 0,
    Aktivno = 1,
    Arhivirano = 9
}

export enum DokumentVrsta {
    Thumbnail = 0,
    IzobrazevanjeDokument = 1,
}

export enum eCourseStatus {
    Draft = 0,
    Active = 1,
}

export const PostsPerPage: number = 15;